import { render, staticRenderFns } from "./OfferConfigureStepSalary.vue?vue&type=template&id=9523d1d0&scoped=true&"
import script from "./OfferConfigureStepSalary.vue?vue&type=script&lang=js&"
export * from "./OfferConfigureStepSalary.vue?vue&type=script&lang=js&"
import style0 from "./OfferConfigureStepSalary.vue?vue&type=style&index=0&id=9523d1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9523d1d0",
  null
  
)

export default component.exports